export const PAPEL_LABEL = {
  contratante: "Contratante (LAB)",
  contratado: "Contratado (Cliente)",
  testemunha_1: "Testemunha 1",
  testemunha_2: "Testemunha 2",
};

export const DECLARACAO = {
  contratante: "Declaro que represento a Locar Ativo Brasil e concordo com os termos desta proposta",
  contratado: "Declaro que li a proposta e concordo com as condições apresentadas",
  testemunha_1: "Declaro que presenciei a celebração deste acordo entre as partes",
  testemunha_2: "Declaro que presenciei a celebração deste acordo entre as partes",
};

export const STATUS_GERAL = {
  pendente: { label: "Pendente", color: "#64748b", bg: "#f1f5f9" },
  parcial: { label: "Parcial", color: "#b45309", bg: "#fef3c7" },
  completa: { label: "Completa", color: "#15803d", bg: "#dcfce7" },
};

export const fmtBRL = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fmtDataHora = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "");

export const fmtCPF = (c) => {
  const d = (c || "").replace(/\D/g, "");
  return d.length === 11 ? `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}` : c || "";
};
